
export default function StrategySection() {
  const strategies = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'Adapter notre politique de prix à vos besoins',
      description: 'Des tarifs flexibles et transparents selon votre budget',
      color: 'text-green-500'
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Gestion transparente de votre budget',
      description: 'Suivi détaillé et communication claire sur tous les coûts',
      color: 'text-blue-500'
    },
    {
      icon: 'ri-medal-line',
      title: 'Rapport qualité-prix imbattable',
      description: 'Excellence technique au meilleur prix du marché',
      color: 'text-orange-500'
    },
    {
      icon: 'ri-time-line',
      title: 'Respect des délais',
      description: 'Planification rigoureuse et livraison dans les temps',
      color: 'text-purple-500'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Intégrité et dynamisme',
      description: 'Approche éthique et proactive dans tous nos projets',
      color: 'text-red-500'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Notre stratégie d'action
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une approche méthodique et transparente pour garantir votre satisfaction
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {strategies.map((strategy, index) => (
            <div 
              key={index}
              className="group bg-gray-50 p-8 rounded-xl hover:bg-white hover:shadow-xl transition-all duration-300"
            >
              <div className={`w-16 h-16 ${strategy.color} bg-white rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <i className={`${strategy.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {strategy.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {strategy.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
